import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Component } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
import { PdvService } from '@app/services/pdv/pdv.service';
import { ProductService } from '@app/services/product/product.service';
import { FamilyService } from '@app/services/family/family.service';
@Component({
    selector: 'carte-filter',
    templateUrl: 'carte-filter.component.html',
    styleUrls: ['carte-filter.component.scss']
})
export class CarteFilterComponent {
    bsModalRef: BsModalRef;
    compositions: any[] = [];
    itemsCompositions: any[] = [];
    selectedComp: any[] = [];
    products: any[] = [];
    chosenOrderType: number;
    subscriptions2: Subscription[] = [];
    orderTypes: any[];
    loadProducts: boolean = true;
    orderProg;
    orderType;
    constructor(private orderService: OrdersService,
        private pdvService: PdvService,
        private productService: ProductService,
        private toastr: ToastrService,
        private familyService: FamilyService,
        private router: Router) {
        let subs5 = this.orderService.orderType.subscribe((orderType: number) => {
            this.orderType = orderType;
        });
        const subs1 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs2 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
        });
        const subs3 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
        });
        const subs4 = this.orderService.selectedComp.subscribe(
            s => {
                if (s.length > 0) {
                    this.changedCompositions(s)
                } else {
                    this.familyService.families.subscribe(
                        (families: any[]) => {
                            this.router.navigate(['/carte/famille/' + families[0].slug])
                        }
                    )
                }
            }
        )
        this.subscriptions2.push(subs1, subs2, subs3, subs4, subs5);
    }

    changedCompositions(selectedComp) {
        if (selectedComp.length > 0) {
            this.productService.getElementByCompositions(selectedComp, this.orderType, this.orderProg).subscribe(
                (products: any[]) => {
                    this.products = products;
                    this.loadProducts = false;
                    if (products.length == 0) {
                        this.toastr.error('Aucun produit disponible');
                        this.familyService.families.subscribe(
                            (families: any[]) => {
                                this.orderService.selectedComp.next([]);
                                this.router.navigate(['/carte/famille/' + families[0].slug])
                            }
                        )
                    }
                }
            )
        } else {
            this.products = [];
        }

    }


    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }
}
